import { Mesh, MeshBasicMaterial, type Vector3 } from 'three'
import { DrawUtils } from '@/plugins/cad/module/utils'

/**
 * 标注箭头渲染对象，三角形 Mesh，方向可调。
 */
export class ArrowObject extends Mesh {
  constructor(options: { color?: number; length?: number; material?: MeshBasicMaterial } = {}) {
    const { color = 0xffffff, length = 2.5 } = options
    const geometry = DrawUtils.createArrowShape(length, length / 3)
    const material =
      options.material || new MeshBasicMaterial({ color, depthTest: false, depthWrite: false })
    super(geometry, material)
  }

  /**
   * 更新箭头的位置与朝向。
   *
   * @param point - 箭尖位置
   * @param direction - 标注线方向向量
   * @param isReversed - 是否翻转到外侧
   */
  update(point: Vector3, direction: Vector3, isReversed: boolean) {
    this.position.copy(point)
    let angle = Math.atan2(direction.y, direction.x)
    if (isReversed) angle += Math.PI // 向外指
    this.rotation.z = angle
  }
}
